import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/IGBTTechnologyESPHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-36.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ige2 { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .ige2-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .ige2-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .ige2-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ige2-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ige2-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .ige2-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ige2-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ige2-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ige2-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ige2-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ige2-bc-item:hover { color: #EB2019; }
  .ige2-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ige2-bc-sep img { width: 24px; height: 24px; display: block; }
  .ige2-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .ige2-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .ige2-main-section { padding: 80px 0 120px 0; }
  .ige2-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .ige2-article { flex: 1; min-width: 0; }

  .ige2-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ige2-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .ige2-meta-item:last-child { border-right: none; padding-right: 0; }
  .ige2-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .ige2-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .ige2-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .ige2-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ige2-article-body p { margin-bottom: 0px; margin-top:20px; }
  .ige2-article-body p:last-child { margin-bottom: 0; }

  .ige2-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  /* Manual numbered item */
  .ige2-num-item {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin: 20px 0 20px 0;
  }
  .ige2-num-item .ige2-num {
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .ige2-num-item .ige2-num-body { flex: 1; }

  /* Bullet ul list */
  .ige2-article-body ul {
    list-style: none; margin: 20px 0 20px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .ige2-article-body ul li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ige2-article-body ul li::before {
    content: '•';
    font-weight: 700; color: #202020;
    flex-shrink: 0; font-size: 18px; line-height: 160%;
  }
  .ige2-article-body ul li > span { flex: 1; }

  .ige2-article-body strong { font-weight: 600; color: #202020; }

  .ige2-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .ige2-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .ige2-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .ige2-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .ige2-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .ige2-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ige2-nav-btn:hover { color: #EB2019; }
  .ige2-nav-btn img { width: 40px; height: 40px; display: block; }

  .ige2-share-icons { display: flex; align-items: center; gap: 20px; }
  .ige2-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .ige2-share-icon:hover { opacity: 0.85; }
  .ige2-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ige2-sidebar { flex: 0 0 475px; }
  .ige2-sidebar-block { margin-bottom: 60px; }
  .ige2-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .ige2-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ige2-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ige2-recent-item:hover .ige2-recent-title { color: #EB2019; }
  .ige2-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
    .para1{ font-weight:600;}
  .ige2-recent-body { flex: 1; min-width: 0; }
  .ige2-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .ige2-social-icons { display: flex; align-items: center; gap: 30px; }
  .ige2-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ige2-social-icon:hover { opacity: 0.8; }
  .ige2-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ige2-hero             { height: 350px; }
    .ige2-hero-content     { padding: 0 32px; }
    .ige2-hero-title       { font-size: 30px; }
    .ige2-hero-divider     { width: 100%; max-width: 575px; }
    .ige2-breadcrumb       { padding: 24px 0 0 0; }
    .ige2-breadcrumb-inner { padding: 0 32px; }
    .ige2-inner            { padding: 0 32px; }
    .ige2-main-section     { padding: 48px 0 60px 0; }
    .ige2-main-row         { flex-direction: column; gap: 48px; }
    .ige2-sidebar          { flex: none; width: 100%; }
    .ige2-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ige2-hero             { height: 360px; }
    .ige2-hero-content     { padding: 0 16px; }
    .ige2-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ige2-hero-divider     { width: 100%; }
    .ige2-hero-subtitle    { font-size: 14px; }
    .ige2-breadcrumb       { padding: 30px 0 0 0; }
    .ige2-breadcrumb-inner { padding: 0 16px; }
    .ige2-bc-item          { font-size: 14px; gap: 14px; }
    .ige2-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ige2-bc-sep img       { width: 22px; height: 22px; }
    .ige2-inner            { padding: 0 16px; }
    .ige2-main-section     { padding: 30px 0 60px 0; }
    .ige2-main-row         { flex-direction: column; gap: 60px; }
    .ige2-sidebar          { flex: none; width: 100%; }
    .ige2-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ige2-article-body     { font-size: 14px; }
    .ige2-article-body p   { margin-bottom: 15px; }
    .ige2-num-item         { font-size: 14px; }
    .ige2-article-body ul li { font-size: 14px; }
    .ige2-article-body strong { font-size: 16px; }
    .ige2-meta-item        { font-size: 14px; }
    .ige2-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .ige2-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .ige2-h2               { font-size: 16px; margin: 20px 0 0px 0; }
    .ige2-hashtags         { margin-top: 30px; font-size: 14px; }
    .ige2-nav-btn img      { width: 24px; height: 24px; }
    .ige2-nav-btn          { font-size: 14px; }
    .ige2-share-icon img   { width: 34px; height: 34px; }
    .ige2-sidebar-title    { font-size: 20px; }
    .ige2-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function IGBTTechnologyESP2() {
  return (
    <div className="ige2">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ige2-hero">
        <img className="ige2-hero-bg" src={HeroBgImg} alt="Improving Particulate Collection Efficiency IGBT Technology Hero" />
        <div className="ige2-hero-overlay" />
        <div className="ige2-hero-content">
          <h1 className="ige2-hero-title">
            Improving Particulate Collection Efficiency in Electrostatic Precipitators in Coal-Fired Power Plants with Advanced IGBT Technology
          </h1>
          <hr className="ige2-hero-divider" />
          <p className="ige2-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ige2-breadcrumb" aria-label="Breadcrumb">
        <div className="ige2-breadcrumb-inner">
          <a href="/" className="ige2-bc-item">Home</a>
          <span className="ige2-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ige2-bc-item">News &amp; Updates</a>
          <span className="ige2-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ige2-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ige2-main-section">
        <div className="ige2-inner">
          <div className="ige2-main-row">

            {/* ── ARTICLE ── */}
            <article className="ige2-article">

              {/* Meta bar */}
              <div className="ige2-meta-bar">
                <span className="ige2-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ige2-meta-item"><img src={CalendarIcon} alt="date" /> October 4, 2024</span>
                <span className="ige2-meta-item"><img src={ClockIconImg} alt="time" /> 6:51 am</span>
                <span className="ige2-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ige2-article-title">
                Improving Particulate Collection Efficiency in Electrostatic Precipitators in Coal-Fired Power Plants with Advanced IGBT Technology
              </h1>

              {/* Body */}
              <div className="ige2-article-body">

                <p>Coal-fired power plants encounter strict environmental laws, particularly when handling particulate emissions. Electrostatic precipitators (ESPs) are crucial in catching fine particles from flue gases, guaranteeing purer emissions. Yet, as the need for more elevated efficiency rises, traditional ESP systems are being improved with state-of-the-art technologies like <a href="#" className="ige2-red-link-plain">IGBT modules</a> (Insulated Gate Bipolar Transistors). These advanced power electronics are critical in enhancing the performance and efficiency of ESPs, especially in coal-fired power plants.</p>

                {/* Article image */}
                <img className="ige2-article-img" src={ArticleImg} alt="IGBT Technology in ESP Coal-Fired Power Plants" />

                <p>Let us explore how <strong>IGBT modules technology</strong> is revolutionizing ESPs, improving particulate accumulation, and donating to the environmental objectives of coal-fired power plants.</p>

                {/* ── Item 1 ── */}
                <div className="ige2-num-item">
                  <span className="ige2-num">1.</span>
                  <span className="ige2-num-body"><strong>Understanding the Role of IGBT Modules in ESPs</strong><br />
                  <strong>IGBT modules</strong> are advanced semiconductor devices that integrate the most valuable properties of both MOSFETs and BJTs, qualifying for high efficiency and fast switching abilities in power conversion systems. These modules are critical in handling the high-voltage power supply required to operate ESPs effectively in electrostatic precipitators.<br /><br />
                  Traditional ESP systems rely on older, less efficient power conversion technologies, which can result in energy losses and reduced particulate collection efficiency. Integrating IGBT modules enhances power control, delivering more precise voltage regulation. This directly improves the ESP's ability to capture fine particles, ash, and soot from the exhaust gases of coal-fired power plants.</span>
                </div>

                {/* ── Item 2 ── */}
                <div className="ige2-num-item">
                  <span className="ige2-num">2.</span>
                  <span className="ige2-num-body"><strong>Improved Efficiency in Particulate Collection</strong><br />
                  The efficiency of an <a href="#" className="ige2-red-link-plain">electrostatic precipitator</a> hinges on its capability to render a high-voltage electric field that ionizes the particles in the flue gas, forcing them to be drawn to and deposited on collection plates. IGBT modules deliver several critical benefits.</span>
                </div>

                <p className="para1">They are:</p>

                <ul>
                  <li><span><strong>Faster Switching Speeds:</strong> The fast-switching capability of IGBT modules allows for more efficient control of the high-voltage DC power supplied to the ESP. This leads to better voltage stability, ensuring the ESP operates optimally.</span></li>
                  <li><span><strong>Reduced Energy Losses:</strong> Traditional Thyristor-based power supplies often suffer from energy losses, particularly during conversion. IGBT modules minimize these losses, ensuring more power is directed toward maintaining the electric field within the ESP. This translates to higher collection efficiency and reduced operational costs.</span></li>
                  <li><span><strong>Enhanced Voltage Control:</strong> With IGBT technology, you can rigorously control the power supply voltage, permitting a more uniform and trustworthy function of the ESP, even under unstable load conditions. This improved control is critical for maintaining the significance of particulate collection in coal-fired power plants with varying operating conditions.</span></li>
                </ul>

                {/* ── Item 3 ── */}
                <div className="ige2-num-item">
                  <span className="ige2-num">3.</span>
                  <span className="ige2-num-body"><strong>Impact on Environmental Compliance</strong><br />
                  As coal-fired power plants face increasing pressure to decrease their environmental impact, enhancing the performance of emission control systems like ESPs is critical. By incorporating <strong>IGBT modules</strong>, power plants can significantly improve the performance of their ESPs, resulting in better compliance with environmental regulations.</span>
                </div>

                <ul>
                  <li><span><strong>Higher Particulate Removal Rates:</strong> IGBT-based ESP systems can catch more particulate matter from flue gases with enhanced voltage control and decreased energy losses. This assures that the plant stays within acceptable emission limitations, allowing it to avoid regulatory fines and damages.</span></li>
                  <li><span><strong>Lower Carbon Footprint:</strong> The increased efficiency brought about by IGBT technology reduces the overall energy consumption of the ESP system, contributing to a lower carbon footprint for the coal-fired power plant. This is particularly important as the global energy sector transitions towards more sustainable practices.</span></li>
                </ul>

                {/* ── Item 4 ── */}
                <div className="ige2-num-item">
                  <span className="ige2-num">4.</span>
                  <span className="ige2-num-body"><strong>Reduced Maintenance and Downtime</strong><br />
                  Another crucial benefit of IGBT modules in <a href="/#" className="ige2-red-link-plain">electrostatic precipitators</a> is their durability and trustworthiness. These modules are known for resisting extreme functional conditions, making them perfect for coal-fired power plants.</span>
                </div>

                <ul>
                  <li><span><strong>Lower Maintenance Costs:</strong> IGBT modules are longer-lasting than more aging power conversion technologies, which decreases the demand for routine maintenance and component replacement. This reduces operational expenses and ensures the ESP system functions constantly without interruptions.</span></li>
                  <li><span><strong>Reduced Downtime:</strong> By delivering regular voltage control, IGBT modules minimize the possibility of ESP shutdowns due to voltage fluctuations or power supply problems. This decreases downtime, assuring that coal-fired power plants maintain continued operations and bypass expensive production failures.</span></li>
                </ul>

                <span className="ige2-h2">Wrapping Up</span>

                <p>Integrating IGBT power modules into electrostatic precipitators (ESPs) is a substantial step forward in enhancing particulate collection efficiency and decreasing emissions in coal-fired power plants. By optimizing the performance of discharge electrodes and leveraging high-power capabilities, IGBT technology ensures more rapid switching speeds, decreased energy losses, and improved voltage control. These advancements significantly enhance the efficiency of both wet electrostatic precipitators (wet ESPs) and dry electrostatic precipitators (dry ESPs).</p>

                <p>The technology effectively charges particles in the gas stream by imparting negatively charged electrical charges, enabling efficient collection and removal. This ensures that power plants meet stringent environmental regulations while reducing operational outlay and improving overall performance.</p>

                <p><a href="/contact-us" className="ige2-red-link-plain">Contact us</a> now to learn how we can help you optimize your ESP systems for the highest efficiency and compliance.</p>

                <p className="ige2-hashtags"><strong>#IGBTModules #ElectrostaticPrecipitators #EmissionControl #EnergyEfficiency #EnvironmentalCompliance</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ige2-bottom-row">
                <div className="ige2-bottom-nav">
                  <a href="/news/transformer-rectifiers-coal-power" className="ige2-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/understanding-esp-components" className="ige2-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ige2-share-icons">
                  <a href="#" className="ige2-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="ige2-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="ige2-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ige2-sidebar">

              {/* Recent Posts */}
              <div className="ige2-sidebar-block">
                <p className="ige2-sidebar-title">Recent Posts</p>
                <div className="ige2-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ige2-recent-item">
                      <img src={post.img} alt={post.title} className="ige2-recent-img" />
                      <div className="ige2-recent-body">
                        <span className="ige2-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ige2-sidebar-block">
                <p className="ige2-sidebar-title">Social Media</p>
                <div className="ige2-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="ige2-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ige2-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}